import {makeStyles} from '@material-ui/core'

// @ts-ignore
export default makeStyles(theme => ({
  root: expanded => ({
    display: 'inline-block',
    position: 'relative',
    width: expanded ? 240 : 40,
    height: 36,
    '&:hover': {
      background: theme.palette.background,
    },
    transition: '.3s all ease',
  }),
  button: expanded => ({
    position: 'absolute',
    right: expanded ? 4 : '50%',
    top: '50%',
    transform: expanded ? 'translateY(-50%)' : 'translate(50%, -50%)',
    pointerEvents: expanded && 'none',
    opacity: expanded && '.5',
    padding: 6,
    transition: '.3s all ease',
    color: theme.palette.text.primary,
    height: '100%',
    width: 36,
  }),
  input: expanded => ({
    width: expanded ? '100%' : 0,
    height: '100%',
    paddingRight: 34,
    paddingLeft: 16,
    borderRadius: 16,
    border: `1px solid ${expanded ? theme.palette.primary.main : 'transparent'}`,
  }),
}))
